import { motion } from "framer-motion";
import { FadeUp } from "./Reveal";
import { EXPERIENCE, IMAGES } from "@/lib/site-data";

const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative bg-[#070708] py-28 md:py-40 border-t border-white/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <FadeUp className="max-w-2xl mb-20">
          <span className="overline">// Track Record</span>
          <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl lg:text-6xl tracking-tight text-white leading-[1.0]">
            Thirty years<br />in the field.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-zinc-400 max-w-lg">
            From ultrasonic fuel gauging on the Boeing B777 to modern cloud-connected
            IoT — a portfolio built on systems that had to work the first time.
          </p>
        </FadeUp>

        <div className="relative border-l border-white/10 ml-1 md:ml-2">
          {EXPERIENCE.map((exp, i) => (
            <FadeUp key={i} delay={0.05} className="relative pl-8 md:pl-14 pb-16 last:pb-0">
              {/* Node */}
              <span className="absolute -left-[6.5px] top-1.5 h-3 w-3 rounded-full bg-cyan-400 shadow-[0_0_12px_#00F0FF]" />

              <div className="grid lg:grid-cols-12 gap-8 items-start">
                <div className="lg:col-span-7">
                  <span className="font-mono text-[12px] uppercase tracking-[0.18em] text-cyan-400">
                    {exp.era}
                  </span>
                  <h3 className="mt-3 font-display font-600 text-2xl md:text-3xl text-white tracking-tight">
                    {exp.role}
                  </h3>
                  <p className="mt-1 font-mono text-sm text-zinc-400">{exp.org}</p>
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.16em] text-zinc-600">
                    {exp.industry}
                  </p>

                  <ul className="mt-6 space-y-3">
                    {exp.points.map((p, j) => (
                      <li key={j} className="flex gap-3 text-[15px] leading-relaxed text-zinc-400">
                        <span className="mt-2 h-1 w-1 shrink-0 bg-cyan-400/70" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="lg:col-span-5 w-full">
                  <div className="relative spotlight clip-frame-sm overflow-hidden border border-white/10 h-56 md:h-64">
                    <motion.img
                      src={IMAGES[exp.image]}
                      alt={exp.industry}
                      className="h-full w-full object-cover opacity-90"
                      initial={{ scale: 1.2 }}
                      whileInView={{ scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 1.3, ease: [0.16, 1, 0.3, 1] }}
                    />
                  </div>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
